import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { pxToRem } from '../../../../utils';
import Embed from '../../../../components/Embed/Embed';
import getBorderFocusStyles from '../../getBorderFocusStyles';
export default {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables,
        siteVariables = _ref.theme.siteVariables;
    var borderFocusStyles = getBorderFocusStyles({
      siteVariables: siteVariables
    });
    return Object.assign({
      display: 'inline-block',
      verticalAlign: 'middle',
      position: 'relative',
      cursor: 'pointer',
      width: v.width,
      height: v.height || 'auto',
      outline: 0
    }, borderFocusStyles[':focus'], {
      ':focus-visible': _defineProperty({}, "& .".concat(Embed.slotClassNames.control), Object.assign({
        borderColor: v.focusBorderColor,
        opacity: 1
      }, borderFocusStyles[':focus-visible'])),
      ':hover': _defineProperty({}, "& .".concat(Embed.slotClassNames.control), {
        opacity: 1,
        zIndex: v.zIndex
      })
    });
  },
  control: function control(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables;
    return {
      background: "0 no-repeat ".concat(v.controlBackgroundColor),
      backgroundPositionX: pxToRem(3),
      color: v.controlColor,
      opacity: p.active ? 0 : 1,
      pointerEvents: 'none',
      transition: 'opacity .22s ease-in-out',
      left: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    };
  },
  iframe: function iframe(_ref3) {
    var p = _ref3.props;
    return Object.assign({
      display: 'block'
    }, !p.iframeLoaded && {
      display: 'none'
    });
  }
};